<template>
  <hp6-select :label-text="label" :id="elementId" :label-show-field-optional="showOptionalLabel">
    <select ref="selectRef" v-model="model" name="search-types" @change="onSelectChange">
      <option v-for="item in items" :key="item.value" :value="item.value">{{ item.label }}</option>
    </select>
  </hp6-select>
</template>


<script setup>

  /**
   *  The FCPSelect component wraps up an hp-select component and provides vue v-model integration so that the user of the component
   * can 2 way bind the selected attribute of the Select to an attribute in an object.
   *
   * label - The label that describes the Select
   * items - The items to display and manage in the hp-select.  An item is an object in the following format:
   * { label: '', value: '' }
   *
   * value - represents the value that has been bound to via v-model.
   *
   * Example:
   *
   * data: function() {
   *  return {
   *      items: [
   *          { label: 'item 1', value: 'item1'}
   *          { label: 'item 2', value: 'item2'}
   *      ]
   *      selected: 'item1'
   *  }
   * }
   *
   * <FCPSelect elementId=="id1" label="My label" :items="items" v-model="selected"></FCPSElect>
   */

    const props = defineProps({
        elementId: {
            type: String
        },
        label: {
            type: String
        },
        labelSize: {
          type: String,
          default: 'xs'
        },
        items: {
            type: Array
        },
        showOptionalLabel: {
          type: Boolean,
          default: false
        },
    })

    const model = defineModel()

    const emit = defineEmits(['change'])

    const onSelectChange = (event) => {
      emit('change', event.target.value)
    }

</script>

<style scoped lang="scss">
hp6-select {
  --field-height-md: 40px;
}
</style>
